<template>
  <div class="c-checkbox">
    <div class="c-checkbox__form-group">
      <input
        :checked="value"
        :disabled="readonly"
        @change="(e) => $emit('change', e)"
        class="c-checkbox__form-group__input"
        :class="{ 'c-checkbox__form-group__input--opposite': opposite }"
        type="checkbox"
        :id="rndId"
      />
      <label
        class="c-checkbox__form-group__label"
        :class="{
          'c-checkbox__form-group__label--opposite': opposite,
          'c-checkbox__form-group__label--not-all': notAll,
        }"
        :for="rndId"
        >{{ label }}
      </label>
    </div>
  </div>
</template>

<script>
import { makeid } from "@utils/makeid.js";
export default {
  props: {
    value: {
      default: false,
      type: Boolean,
    },
    readonly: {
      default: false,
      type: Boolean,
    },
    notAll: {
      default: false,
      type: Boolean,
    },
    opposite: {
      default: false,
      type: Boolean,
    },
    label: {
      default: "",
    },
  },
  data() {
    return {
      rndId: "",
    };
  },
  mounted() {
    this.rndId = makeid(5);
  },
};
</script>

<style></style>
